import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {CDSNode, Rule} from "../../services/capd.model";
import {OrgService} from "../../services/org.service";
import {ActivatedRoute} from "@angular/router";
import {OrgDataService} from '../../services/org-data.service';
import * as _ from 'underscore';
import {TenantMappingsComponent} from '../../cds_tenant_mapping/tenant_mappings_org.component';
import {AlertService} from '../../services/alert.service';
import {RulesService} from '../../services/rules.service';
import {CDSTreeService} from '../../services/cds.service';
import {ExportToCsv} from 'export-to-csv';


@Component({
    selector: 'company',
    templateUrl: './company.component.html',
    styleUrl: './company.component.less'
})

export class CompanyContentComponentV2 implements OnInit {

    ruleList: Rule[] = [];
    selectRulesEnabled = false;
    toAddOrDelete: Rule[] = [];
    groupToAdd: CDSNode[] = [];
    private sub: any;
    root: string;
    selectedRule: Rule;
    scope: string;
    canEditOrg: boolean = true;
    orgInTreeRoots: boolean = false;
    org: CDSNode;
    oldRule: Rule = null;
    customRule: Rule = null;
    isDisabled = true;
    deleteEnabled = false;
    groupAssignEnabled = false;
    hasGroups = 'loading';
    groupList: CDSNode[];
    haveRulesBeenFiltered = false;
    tenant = "";
    loadInit: boolean = true;
    quillModules = {
        clipboard: {
            matchVisual: false
        },
        toolbar: [
            ['bold', 'italic', 'underline'], // Formatting buttons
            [{ 'list': 'ordered'}, { 'list': 'bullet' }], // List buttons
            ['link'] // Link button for creating hyperlinks
        ]
    };
    rootRule: Rule = null;
    rulesNotAdded: any = [];
    csvDataRulesNotAdded: any = [];
    @ViewChild('warningRulesNotAdded', null) warningRulesNotAdded: ElementRef;
    csvData: any = [];
    exporting = false;

    // Variables for the Sync modal
    isSyncDisabled = true;

    constructor(private _service: OrgService,
                private _cdsTreeService: CDSTreeService,
                private _route: ActivatedRoute,
                private _el: ElementRef,
                private _orgDataService: OrgDataService,
                private _tenantMappingsComponent: TenantMappingsComponent,
                private alertService: AlertService,
                private _rulesService: RulesService) {
    }

    ngOnInit() {
        sessionStorage.removeItem('alerts');
        this.sub = this._route.params.subscribe(params => this.root = params.id);
        this._service.getOrgContent(this.root).then(res => {
            this.ruleList = this.ruleSort(res);
            this.loadInit = false;
        });
        this.scope = sessionStorage.getItem('scope');
        this.org = this._orgDataService.currentOrg;
        this.doUpdate();
    }


    /**
     * Called whenever the list of rules is updated or changed.
     * Gets all current rules and the groups they are assigned to.
     *
     * @func doUpdate
     */
    doUpdate() {
        this.updateCanEdit();
        this.loadInit = true;
        this._service.getOrgContent(this.root).then(res => {
            this.ruleList = this.ruleSort(res);
            this.loadInit = false;
        }).then(() => {
            this.createCsv();
        });

        this.haveRulesBeenFiltered = false;
        this.toAddOrDelete = new Array<Rule>(0);

        this.filterRulesByTenant();
    }

    /**
     * Filters the rules to be displayed based on whether they have customer tenant(s) set and if that matches the mapped tenant for the org
     *
     * @func filterRulesByTenant
     */
    filterRulesByTenant() {
        this._tenantMappingsComponent.expandedRoot = this.org.rootId.replace('~', '2.16.840.1.113883.3.21');
        this._tenantMappingsComponent.loadMapping().then(result => {
            if(this._tenantMappingsComponent.thisMapping && this._tenantMappingsComponent.thisMapping.tenant) {
                this.tenant = this._tenantMappingsComponent.thisMapping.tenant;
                this._service.tenant = this.tenant;
            }

            this.ruleList = this.ruleList.filter(rule => {
                return this._service.shouldRuleDisplayBasedOnTenant(rule, this.tenant);
            });

            this.haveRulesBeenFiltered = true;
        });

    }

    onSelect(rule: Rule) {
        if (this.selectRulesEnabled) {
            const index = this.toAddOrDelete.indexOf(rule);
            if (index < 0) {
                this.toAddOrDelete.push(rule);
            } else {
                this.toAddOrDelete.splice(index, 1);
            }
        } else {
            this.selectedRule = rule;
            this.oldRule = JSON.parse(JSON.stringify(this.selectedRule));
            this.customRule = this.selectedRule;
            $(this._el.nativeElement).find('#modal-rule-details').show();
        }
    }

    hideRuleDetails() {
        $(this._el.nativeElement).find('#modal-rule-details').hide();
    }

    replaceMessageText(event: any) {
        this.selectedRule.physicianMessage = event.html;
    }


    /**
     * Prints a list of all groups a rule is assigned to.
     *
     * @func printGroupNames
     * @returns a string of all non-null groupNames, separated by commas.
     * @param rule
     */
    printGroupNames(rule) {
        let groupString = '';
        const noNull: string[] = rule.groupNames.filter(group => !!group);
        for (let i = 0; i < noNull.length - 1; i++) {
            groupString += noNull[i] + ', ';
        }
        if (noNull.length > 0) {
            groupString += noNull[noNull.length - 1];
        }
        return groupString;

    }

    updateCanEdit() {
        let idEnd = this.root.replace('~', '2.16.840.1.113883.3.21').split('.').pop();
        let parentId = this.root.replace('~', '2.16.840.1.113883.3.21').replace('.' + idEnd, '');
        let treeRoots: string[] = sessionStorage.getItem('treeRoots').split(',');
        let companyExtensionCheck = this.org.extensionId.includes('Company');
        let parentIdIncludedInTreeRoots = treeRoots.indexOf(parentId) > -1;

        this.canEditOrg = companyExtensionCheck || parentIdIncludedInTreeRoots;
        this.orgInTreeRoots = treeRoots.indexOf(parentId + this.org.rootId.replace('~', '')) > -1;
    }

    showAddModal() {
        $(this._el.nativeElement).find('#modal-assign-content').show();
    }

    saveChanges() {
        this.selectedRule.lastUpdatedBy = sessionStorage.getItem('username');
        this.convertActionableList();
        this._service.updateOrgRule(this.root, this.selectedRule.triggerCode, this.selectedRule).then(() => {
            this.doUpdate();
        });
        this.hideRuleDetails();
    }

    convertActionableList() {
        // Backend actionableList is a string list, but when we put this into the text box it becomes a string
        // translate back to a readable form for backend
        if (this.selectedRule.actionableList != null) {
            // we can only translate the actionable list if it is a string;
            // if it is already an object, it probably does not need to be updated
            if(typeof this.selectedRule.actionableList == 'string')
                //@ts-ignore
                this.selectedRule.actionableList = this.selectedRule.actionableList.split(",");
        } else {
            // if the list is null, we want to save an empty array
            this.selectedRule.actionableList = [];
        }
    }
    /**
     * Checks to see if a rule has been changed from its original state.
     *
     * @func isUnchanged
     * @returns true if the rule has NOT been changed; false otherwise.
     */
    isUnchanged() {
        if (this.oldRule && this.selectedRule && this.selectedRule.physicianMessage != null) {
            let oldRuleClone = this.replaceRuleTextForCompare(JSON.parse(JSON.stringify(this.oldRule)));
            let selectedRuleClone = this.replaceRuleTextForCompare(JSON.parse(JSON.stringify(this.selectedRule)));
            return (JSON.stringify(oldRuleClone) == JSON.stringify(selectedRuleClone));
        } else {
            return true;
        }
    }

    /**
     * Replaces encoded values and tags added by the third party text box used in the rule edit modal
     * We do this so that the value matches the initial input, and can be compared
     * @param rule
     */
    replaceRuleTextForCompare(rule) {
        let ruleJson = JSON.stringify(rule).replaceAll('&nbsp;', ' ').replaceAll('<br>', '')
            .replaceAll('&lt;', '<').replaceAll('&gt;', '>').replaceAll('<p>', '')
            .replaceAll('/r', '').replaceAll('/n', '')
            .replaceAll(' rel=\\"nofollow noopener noreferrer\\"', '')
            .replaceAll(' rel=\\"noopener noreferrer\\"', '')
            .replaceAll('</p>', '');
        let newRule = JSON.parse(ruleJson);
        newRule.physicianMessage = newRule.physicianMessage.trim();
        return newRule;
    }


    onHeaderSelect() {
        if (this.toAddOrDelete.length >= this.ruleList.length) {
            this.toAddOrDelete = [];
        }
        else {
            this.ruleList.forEach(rule => this.toAddOrDelete.push(rule));
        }
    }

    checkSelected() {
        if($('input[type=checkbox]:not(:checked)')) {
            $('#selectAllRules').prop('checked', false);
        }
    }

    onDelete() {
        this.hideDeleteModal();
        this.selectRulesEnabled = false;
        let triggerCodes: string[] = [];
        this.deleteEnabled = false;
        this.toAddOrDelete.forEach(rule => {
            triggerCodes.push(rule.triggerCode);
        });
        this._service.deleteOrgRules(this.root, triggerCodes).then(() => {
            this.loadInit = true;
            this._service.getOrgContent(this.root).then(res => {
                this.ruleList = this.ruleSort(res);
                this.loadInit = false;
            });
        });
        this.clearSelections();
    }

    hideDeleteModal() {
        $(this._el.nativeElement).find('#modal-delete-org-rules').hide();
    }

    showDeleteModal() {
        $(this._el.nativeElement).find('#modal-delete-org-rules').show();
    }

    /**
     * Toggle checkbox that disables the delete button by default.
     *
     * @func toggleDisabled
     */
    toggleDisabled() {
        this.isDisabled = !this.isDisabled;
    }

    showGroupAssignModal() {
        $(this._el.nativeElement).find('#modal-group-assign-rules').show();
    }

    getOrgGroups() {
        this._service.getGroups(this.org).then((groups :CDSNode[]) =>
            this.groupList = groups.sort(function(a, b) {
                const asplit = a.description.split(/\s?\/\s?/);
                const bsplit = b.description.split(/\s?\/\s?/);
                if (asplit.length - bsplit.length === 0) {
                    let compareReturn = asplit[0].localeCompare(bsplit[0]);
                    let i = 1;
                    while (compareReturn === 0 && i < asplit.length) {
                        compareReturn = asplit[i].localeCompare(bsplit[i]);
                        i++;
                    }
                    return compareReturn;
                }
                else if (asplit.length < bsplit.length) {
                    return -1;
                }
                else {
                    return 1;
                }
            })
        ).then(() => {
            if(this.groupList && this.groupList.length > 0) {
                this.hasGroups = 'true';
            } else {
                this.hasGroups = 'false';
            }
        });
    }

    getRefreshedBranchGroups() {
        this._service.getGroups(this.org).then((groups: CDSNode[]) => {
            this.groupList = groups
                .filter(group => (group as any)?.type === 'SettingsGroup')
                .sort((a, b) => (a.description || '').localeCompare((b.description || ''), undefined, { sensitivity: 'base' }));
            if(this.groupList && this.groupList.length > 0) {
                this.hasGroups = 'true';
            } else {
                this.hasGroups = 'false';
            }
        });
    }

    hideGroupAssignModal() {
        $(this._el.nativeElement).find('#modal-group-assign-rules').hide();
    }

    cancelSelection() {
        this.deleteEnabled = false;
        this.groupAssignEnabled = false;
        this.selectRulesEnabled = false;
    }

    /**
     * Adds or removes a selected option to the list of groups to add rules to.
     *
     * @func updateChecked
     * @param {any} option - the option to add or remove.
     */
    updateChecked(option) {
        // Check to see if the option is in the array
        const index = this.groupToAdd.indexOf(option);
        // If it's not, add it to the end
        if (index < 0) {
            this.groupToAdd.push(option);
        }
        // Otherwise, remove it
        else {
            this.groupToAdd.splice(index, 1);
        }
    }

    /**
     * Confirms the list of groups and assigns the selected rules to the selected groups.
     *
     * @async
     * @func onSubmit
     */
    async onSubmit() {
        let matchedRulesGroups = [];
        let identifiedGroupOids = [];
        this.rulesNotAdded = [];

        // get all rules assigned to the selected groups
        // check to see if there are any matching trigger codes between the currently assigned rules and the rules to be assigned
        await this._service.getRulesForGroupsV2(this.groupToAdd).then((rules: Rule[]) => {
            const matchedRules = rules.filter(rule => this.toAddOrDelete.some(x => x.triggerCode == rule.triggerCode));
            matchedRulesGroups = _.groupBy(matchedRules, 'groupId');
            identifiedGroupOids = [... new Set(rules.map(rule => rule.groupId))];
        });

        // if all of the rules will be new to the groups, proceed as normal
        // else, identify what we need to skip
        if(Object.keys(matchedRulesGroups).length == 0) {
            this.assignRulesToGroups(this.toAddOrDelete, this.groupToAdd, this.root);
        } else {
            // identify any groups we can add a to
            const groupsToAddAll = this.groupToAdd.filter(grp => !identifiedGroupOids.includes(grp.rootId + '/' + grp.extensionId) );
            if (groupsToAddAll != undefined && groupsToAddAll.length != 0) {
                this.assignRulesToGroups(this.toAddOrDelete, groupsToAddAll, this.root);
            }

            // for each oid, identify the rules that we can assign and then assign only those rules
            identifiedGroupOids.forEach(oid => {
                let rulesToAdd = [];
                if (matchedRulesGroups[oid] && matchedRulesGroups[oid].length > 0) {
                    rulesToAdd = this.toAddOrDelete.filter(r => !matchedRulesGroups[oid].some(x => r.triggerCode == x.triggerCode));
                    matchedRulesGroups[oid].filter(r => this.toAddOrDelete.some(x => r.triggerCode == x.triggerCode)).forEach(r => {
                        this.rulesNotAdded.push(r);
                    });;
                }
                const groupNode = this.groupToAdd.filter(grp => grp.rootId + '/' + grp.extensionId == oid);
                if (rulesToAdd.length > 0) {
                    this.assignRulesToGroups(rulesToAdd, groupNode, this.root);
                }

                if(this.rulesNotAdded.length != 0){
                    this.warningRulesNotAdded.nativeElement.classList.toggle("show");
                }
            });
            }
        }

    cancelRuleAssign() {
        $('input[type=checkbox]').prop('checked', false);
        this.clearSelections();
        this.hideGroupAssignModal();
    }

    clearSelections() {
        this.toAddOrDelete = new Array(0);
        this.groupToAdd = new Array(0);

        // reset delete confirmation checkbox
        //@ts-ignore
        document.getElementById('cboxConfirm').checked = false;
    }

    async assignRulesToGroups(rulesToAdd, groups, root) {
        await this._service.assignRulesToGroupsV2(rulesToAdd, groups, root).then(() => {
            this.hideGroupAssignModal();
        }).then(() => {
            this.doUpdate();
            let successAddedToGroupMessage = "Content successfully added to ";
            if (groups.length === 1) {
                successAddedToGroupMessage += groups[0].description;
            } else {
                successAddedToGroupMessage += groups.length + " groups";
            }
            this.alertService.showAlert(successAddedToGroupMessage);
            this.cancelSelection();
            this.clearSelections();
            groups = new Array(0); rulesToAdd = new Array(0);
        });
    }

    ruleSort(res: Rule[]){
        if (res.length !== undefined && res.length !== 0) {
            return res.sort(function(a, b) {
                let compare = a.triggerName.toLowerCase().localeCompare(b.triggerName.toLowerCase());
                if (compare === 0) {
                    return a.triggerCode.toLowerCase().localeCompare(b.triggerCode.toLowerCase());
                }
                return compare;
            });
        } else {
            return [];
        }
    }

    showSyncModal() {
        this._rulesService.getRuleByTriggerCodeV2(this.selectedRule.triggerCode).then(res => {
            this.rootRule = res;
        });
        $(this._el.nativeElement).find('#modal-sync-pack').show();
    }

    hideSyncModal() {
        $(this._el.nativeElement).find('#modal-sync-pack').hide();
    }

    /**
     * Toggle checkbox that disables the sync button by default.
     *
     * @func toggleSyncDisabled
     */
    toggleSyncDisabled() {
        this.isSyncDisabled = !this.isSyncDisabled
    }


    /**
     * Syncs the Message Title and Fluency Direct Message
     * of the nude/rule to the defaults in the M*Modal library.
     *
     * @async
     * @func onSync
     */
    onSync() {
        this.selectedRule.lastUpdatedBy = sessionStorage.getItem('username');
        this.selectedRule.physicianMessage = null;
        this.selectedRule.physicianTitle = null;
        this.selectedRule.actionableList = [];
        this._service.updateOrgRule(this.root, this.selectedRule.triggerCode, this.selectedRule).then(() => {
            this.doUpdate();
        });
        this.hideRuleDetails();
        this.hideSyncModal();
    }

    onHideRulesNotAdded() {
        this.warningRulesNotAdded.nativeElement.classList.toggle('show');
        this.cancelRuleAssign();
        this.cancelSelection();
    }

    createRulesNotAddedCsv() {
        this.csvDataRulesNotAdded = [];
        this.rulesNotAdded.forEach(rule => {
            const csvRule = {
                Group: this.getGroupName(rule.groupId),
                TriggerCode: rule.triggerCode,
                RuleName: rule.triggerName
            };
            this.csvDataRulesNotAdded.push(csvRule);
        });
    }

    async exportCsvOfNotAddedRules() {
        await this.createRulesNotAddedCsv();
        const options = {
            filename: this.org.description + '_failed_rule_assignments',
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: true,
            title: 'Rule Group Pairs Not Assigned',
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: true
        };

        const csvExporter = new ExportToCsv(options);

        if (!(this.csvDataRulesNotAdded  === undefined) && this.csvDataRulesNotAdded  !== null) {
            csvExporter.generateCsv(this.csvDataRulesNotAdded);
        } else {
            this.alertService.showAlert('Invalid Export. No data provided.');
        }
    }

    getGroupName(oid) {
        const name = this.groupToAdd.find(g => g.rootId + '/' + g.extensionId === oid).description;
        return name;
    }

    /**
     * Creates a CSV file with data relevant to content providers and marketing teams.
     *
     * @func createCsv
     */
    createCsv() {
        this.exporting = true;
        this.csvData = [];

        this.ruleList.forEach(rule => {
            const csvRule = {
                'Trigger Code': rule.triggerCode,
                'Rule Name': rule.triggerName,
                Modified: rule.triggerInfoModified,
                'Physician Title': rule.physicianTitle,
                'Physician Message': rule.physicianMessage,
                //@ts-ignore
                Groups: String(rule.groupNames.filter(r => r !== null))
            };
            this.csvData.push(csvRule);
        });

        this.exporting = false;
    }

    /**
     * At a user's request, this creates a downloadable .csv
     * file with the aforementioned data.
     *
     * @func exportCsv
     */
    exportCsv() {
        const options = {
            filename: this.org.description + '_' + Date.now(),
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: true,
            title: 'Company Package Export CSV',
            useKeysAsHeaders: false,
            headers: [ 'Trigger Code', 'Rule Name', 'Modified', 'Physician Title', 'Physician Message', 'Groups'],
            useTextFile: false,
            useBom: true
        };

        const csvExporter = new ExportToCsv(options);

        if(!(this.csvData === undefined) && this.csvData !== null) {
            csvExporter.generateCsv(this.csvData);
        } else {
            this.alertService.showAlert('Invalid Export. No data provided.');
        }
    }

}